import { ASSETS } from './assets'

export const quickEntries = [
  { key: 'hotel', title: '订住宿', icon: ASSETS.iconHotel, target: 'hotel' },
  { key: 'food', title: '寻美食', icon: ASSETS.iconFood, target: 'food' },
  {
    key: 'culture',
    title: '赏人文',
    icon: ASSETS.iconCulture,
    target: 'culture',
  },
  {
    key: 'heatmap',
    title: '看热图',
    icon: ASSETS.iconHeatmap,
    target: 'heatmap',
  },
  {
    key: 'heritage',
    title: '爱非遗',
    icon: ASSETS.iconHeritage,
    target: 'heritage',
  },
  {
    key: 'scenic',
    title: '探古迹',
    icon: ASSETS.iconHistoricSite,
    target: 'tourism',
  },
  { key: 'story', title: '有故事', icon: ASSETS.iconStory, target: 'activity' },
  { key: 'guide', title: '看攻略', icon: ASSETS.iconGuide, target: 'guide' },
  { key: 'route', title: '找线路', icon: ASSETS.iconRoute, target: 'route' },
  {
    key: 'service',
    title: '享服务',
    icon: ASSETS.iconService,
    target: 'service',
  },
]

export const homeSections = [
  {
    key: 'activity',
    title: '活动一览',
    type: 'activity',
    categories: ['活动预告', '节庆活动', '赛事活动', '惠民消费'],
  },
  {
    key: 'tourism',
    title: '旅游休闲',
    type: 'imageCards',
    categories: ['文化旅游', '乡村旅游', '红色旅游', '生态旅游'],
  },
  {
    key: 'hotel',
    title: '酒店住宿',
    type: 'imageCards',
    categories: ['酒店宾馆', '特色住宿'],
  },
  {
    key: 'venue',
    title: '文化场馆',
    type: 'imageCards',
    categories: ['图书馆', '文化馆', '博物馆', '文化空间'],
  },
  {
    key: 'food',
    title: '美食购物',
    type: 'imageCards',
    categories: ['餐餐美食', '乐购时尚', '文化休闲'],
  },
  {
    key: 'humanity',
    title: '人文宿城',
    type: 'imageCards',
    categories: ['宿城非遗', '运河文化', '红色记忆', '楚汉故事'],
  },
  {
    key: 'heatmap',
    title: '智慧热图',
    type: 'heatmap',
    categories: ['今日热度', '区县热度', '错峰推荐'],
  },
  {
    key: 'sports',
    title: '赛事文旅',
    type: 'sports',
    categories: ['赛事场馆', '赛后路线', '观众服务'],
  },
]

export const featureCards = [
  {
    id: 101,
    section: 'tourism',
    category: '旅游休闲',
    county: '埇桥区',
    title: '新汴河景区',
    description: '宿州城市滨水休闲景观带，适合夜游、散步和城市打卡。',
    image: ASSETS.tourismXinbianhe,
    distance: '约 3.2km',
    heatScore: 92,
    comfort: '较热',
    tags: ['城市休闲', '夜游', '热门'],
  },
  {
    id: 102,
    section: 'tourism',
    category: '旅游休闲',
    county: '萧县',
    title: '皇藏峪国家森林公园',
    description: '山林幽深，适合周末休闲与亲子自然体验。',
    image: ASSETS.tourismHuangzangyu,
    distance: '约 45km',
    heatScore: 84,
    comfort: '舒适',
    tags: ['生态旅游', '亲子', '热门'],
  },
  {
    id: 103,
    section: 'tourism',
    category: '旅游休闲',
    county: '砀山县',
    title: '砀山梨树王景区',
    description: '砀山梨花与乡村田园体验，百年梨树王见证古今。',
    image: ASSETS.tourismDangshanLishu,
    distance: '约 82km',
    heatScore: 80,
    comfort: '舒适',
    tags: ['生态', '乡村', '节庆'],
  },
  {
    id: 201,
    section: 'venue',
    category: '文化场馆',
    county: '埇桥区',
    title: '宿州市博物馆',
    description:
      '展示宿州历史文化与城市发展脉络，适合研学、亲子和城市文化体验。',
    image: ASSETS.venueMuseum,
    distance: '约 2.5km',
    heatScore: 88,
    comfort: '舒适',
    tags: ['博物馆', '研学', 'AI讲解'],
  },
  {
    id: 401,
    section: 'food',
    category: '美食购物',
    county: '埇桥区',
    title: '符离集烧鸡',
    description: '宿州代表性地方美食之一，中华老字号。',
    image: ASSETS.foodFulijiChicken,
    distance: '约 15km',
    heatScore: 95,
    comfort: '爆热',
    tags: ['美食', '本地特色', '非遗'],
  },
  {
    id: 301,
    section: 'humanity',
    category: '人文宿州',
    county: '灵璧县',
    title: '灵璧奇石文化园',
    description: '灵璧奇石与地方文化展示，天下奇石第一园。',
    image: ASSETS.cultureLingbiStone,
    distance: '约 52km',
    heatScore: 80,
    comfort: '舒适',
    tags: ['奇石', '非遗', '人文'],
  },
  {
    id: 102,
    section: 'tourism',
    category: '生态旅游',
    title: '皇藏峪国家森林公园',
    description: '山林幽深，适合周末休闲与亲子自然体验。',
    image: ASSETS.tourismHuangzangyu,
    distance: '230.6Km',
    heatScore: 84,
    tags: ['生态旅游', '亲子'],
  },
  {
    id: 103,
    section: 'tourism',
    category: '文化旅游',
    title: '砀山梨树王景区',
    description: '砀山梨花与乡村田园体验。',
    image: ASSETS.tourismDangshanLishu,
    distance: '240.1Km',
    heatScore: 80,
    tags: ['文化旅游'],
  },
  {
    id: 104,
    section: 'tourism',
    category: '红色旅游',
    title: '蔡洼淮海战役景区',
    description: '红色记忆与战役遗址。',
    image: ASSETS.tourismCaiwaRed,
    distance: '245.0Km',
    heatScore: 74,
    tags: ['红色旅游'],
  },
  {
    id: 201,
    section: 'venue',
    category: '博物馆',
    title: '宿州市博物馆',
    description: '展示宿州历史文化与城市发展脉络。',
    image: ASSETS.venueMuseum,
    distance: '248.8Km',
    heatScore: 72,
    tags: ['博物馆', '免费开放'],
  },
  {
    id: 301,
    section: 'humanity',
    category: '人文宿城',
    title: '灵璧奇石文化园',
    description: '灵璧奇石与地方文化展示。',
    image: ASSETS.cultureLingbiStone,
    distance: '249.9Km',
    heatScore: 80,
    tags: ['非遗', '人文宿城'],
  },
  {
    id: 401,
    section: 'food',
    category: '餐餐美食',
    title: '符离集烧鸡',
    description: '宿州代表性地方美食之一。',
    image: ASSETS.foodFulijiChicken,
    distance: '250.0Km',
    heatScore: 82,
    tags: ['美食', '本地特色'],
  },
  {
    id: 402,
    section: 'food',
    category: '餐餐美食',
    title: '宿城早餐',
    description: '美好的一天从早餐开始。',
    image: ASSETS.foodBreakfast,
    distance: '250.0Km',
    heatScore: 78,
    tags: ['美食'],
  },
  {
    id: 501,
    section: 'humanity',
    category: '运河文化',
    title: '大运河文化点',
    description: '泗县大运河文化与通济渠景观。',
    image: ASSETS.cultureSixianCanal,
    distance: '246.5Km',
    heatScore: 76,
    tags: ['运河文化'],
  },
  {
    id: 502,
    section: 'humanity',
    category: '文化地点',
    title: '大泽乡涉故台',
    description: '地方历史文化遗存。',
    image: ASSETS.cultureDazexiang,
    distance: '247.2Km',
    heatScore: 70,
    tags: ['人文'],
  },
]

export const activityList = [
  {
    id: 1,
    title: '活动预告｜砀山梨花节即将开启',
    subtitle: '一城梨花，一路春光，品读宿州生态之美',
    image: ASSETS.activityDangshanLihua,
    tag: '活动预告',
    date: '2026年3月-4月',
  },
  {
    id: 2,
    title: '跟着赛事游宿州主题活动',
    subtitle: '看一场比赛，认识一座城市',
    image: ASSETS.activitySportsTour,
    tag: '赛事活动',
    date: '赛事期间',
  },
  {
    id: 3,
    title: '文旅惠民消费季',
    subtitle: '景区、餐饮、住宿、文创优惠一站领取',
    image: ASSETS.activityCoupon,
    tag: '惠民消费',
    date: '持续更新',
  },
]

export const heatAreas = [
  {
    county: '埇桥区',
    heatScore: 92,
    status: '热门',
    mainResource: '宿州市博物馆、新汴河景区',
  },
  {
    county: '砀山县',
    heatScore: 76,
    status: '升温',
    mainResource: '砀山梨树王景区',
  },
  {
    county: '萧县',
    heatScore: 84,
    status: '热门',
    mainResource: '皇藏峪国家森林公园',
  },
  {
    county: '灵璧县',
    heatScore: 69,
    status: '适中',
    mainResource: '灵璧奇石文化园',
  },
  {
    county: '泗县',
    heatScore: 58,
    status: '平稳',
    mainResource: '大运河文化点',
  },
]

export const heatWarnings = [
  '新汴河景区夜游热度上升，建议提前规划返程交通。',
  '皇藏峪周末客流较高，建议错峰出行或选择周边替代线路。',
]
